import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row gap-2 w-full text-sm" }
const _hoisted_2 = { class: "flex items-center border border-black h-8 rounded px-3 py-2 gap-2 w-full bg-white" }
const _hoisted_3 = { class: "whitespace-nowrap" }
const _hoisted_4 = { class: "flex items-center border border-black h-8 rounded px-3 py-2 gap-2 w-full bg-white" }
const _hoisted_5 = { class: "whitespace-nowrap" }

import { mdiCalendarBlankOutline, mdiClockOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimeDisplay',
  props: {
    date: {},
    time: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "small",
        icon: _unref(mdiCalendarBlankOutline),
        color: 'iconGrey'
      }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.date), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_icon, {
        size: "small",
        icon: _unref(mdiClockOutline),
        color: 'iconGrey'
      }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.time), 1)
    ])
  ]))
}
}

})